"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentsHelper = void 0;
const lodash_1 = require("lodash");
const core_1 = require("@integro/core");
class AttachmentsHelper {
    app;
    DEFAULT_FILE_TYPE_ICON = 'vscode-icons:file-type-binary';
    constructor(app) {
        this.app = app;
    }
    downloadAttachmentFromSlickCommand(event) {
        const id = (0, lodash_1.get)(event, 'data.value');
        if (!(0, lodash_1.isString)(id)) {
            return;
        }
        const fieldName = (0, lodash_1.get)(event, 'data.column.field');
        if (!(0, lodash_1.isString)(fieldName)) {
            return;
        }
        const value = (0, lodash_1.get)(event, `data.data.${fieldName}`);
        if (!(0, lodash_1.isNil)(value) && Array.isArray(value)) {
            const item = (0, lodash_1.find)(value, { id });
            if (item) {
                return this.downloadAttachment(item);
            }
        }
        else if ((0, lodash_1.isObject)(value)) {
            const item = value;
            return this.downloadAttachment(item);
        }
    }
    downloadAttachment(data) {
        if (!data) {
            return;
        }
        const url = this.app.connections.urlFor('download_attachment', {
            id: data.id
        });
        return Promise.resolve(core_1.downloads.getFileBLOB(url, data.file_name)).then(p => p && core_1.downloads.showFileInNewTab(p.file, p.fileName));
    }
    downloadInvoiceView(invoiceId, invoiceNumber) {
        if (!invoiceId) {
            return;
        }
        const url = this.app.connections.urlFor('read_invoice_print', {
            id: invoiceId
        });
        return Promise.resolve(core_1.downloads.getFileBLOB(url, `${invoiceNumber}.pdf`)).then(p => p && core_1.downloads.showFileInNewTab(p.file, p.fileName));
    }
    renderAttachmentElement(data, options) {
        let cellContent = (0, lodash_1.get)(data, 'cellContent', null);
        if (cellContent != null) {
            return cellContent;
        }
        const href = this.app.connections.urlFor('download_attachment', {
            id: data.id
        });
        let iconClass = this.getIconClass(data);
        let content = '';
        if (options?.displayFileName) {
            content = `<span class="pl-2">${data.file_name}</span>`;
        }
        if (!iconClass) {
            cellContent = [
                `<a href="#" class="command-link"`,
                ` title="${data.file_name}"`,
                ` data-value="${data.id}"`,
                '>',
                `<i class="fa fa-file"></i>`,
                content,
                '</a>'
            ].join('');
        }
        else {
            cellContent = [
                `<a href="#" class="command-link"`,
                ` title="${data.file_name}"`,
                ` data-value="${data.id}"`,
                '>',
                `<iconify-icon icon="${iconClass}" noobserver></iconify-icon>`,
                content,
                '</a>'
            ].join('');
        }
        (0, lodash_1.set)(data, 'cellContent', cellContent);
        return cellContent;
    }
    getIconClass(data) {
        const extension = data.file_name.indexOf('.')
            ? (0, lodash_1.last)(data.file_name.split('.')).toLowerCase()
            : data.file_name.slice(1, 3);
        return (0, lodash_1.get)(this.app.config['fileTypeIcons'], extension, this.DEFAULT_FILE_TYPE_ICON);
    }
    slickColumnFormatter() {
        const render = this.renderAttachmentElement.bind(this);
        return function attachmentColumnFormatter() {
            const attachmentFormatter = (row, cell, value, columnDef, dataContext, grid) => {
                if ((0, lodash_1.isArray)(value)) {
                    return `<div>${(0, lodash_1.map)(value, render).join(' ')}</div>`;
                }
                const displayFileName = (0, lodash_1.get)(columnDef, "displayFileName", false);
                if ((0, lodash_1.get)(columnDef, "useDataContext") && (0, lodash_1.isObject)(dataContext)) {
                    console.log("useDataContext", dataContext);
                    return render(dataContext, {
                        displayFileName
                    });
                }
                if ((0, lodash_1.isObject)(value)) {
                    return render(value, {
                        displayFileName
                    });
                }
                return '';
            };
            (0, lodash_1.set)(attachmentFormatter, 'exportRawData', false);
            return attachmentFormatter;
        };
    }
}
exports.AttachmentsHelper = AttachmentsHelper;
